module.exports = __webpack_public_path__ + "img/1542226917.f23e223c.jpg";